module.exports = __webpack_public_path__ + "static/media/may_2025_4.8ae57798.webp";